module.exports = __webpack_public_path__ + "img/top_catch04.6c7cb2e5.jpg";